import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from 'react-query'

import Toolbar from './Components/Toolbar';

const Home = lazy(() => import('./Pages/Home'));
const About = lazy(() => import('./Pages/About'));
const Products = lazy(() => import('./Pages/Products'));
const ProductDetails = lazy(() => import('./Pages/ProductDetails'));
const NoMatch = lazy(() => import('./Components/NoMatch'));
const Posts = lazy(() => import('./Pages/posts/Posts'));
const Users = lazy(() => import('./Pages/users/Users'));
const Albums = lazy(() => import('./Pages/albums/Albums'));
const Photos = lazy(() => import('./Pages/photos/Photos'));


const Files = lazy(() => import('./Pages/files/Files'));

const Debug = lazy(() => import('./Pages/debug/Debug'));



const App = () => {

	useEffect(() => {
		document.title = "Sample React";
	  }, []);


	const queryClient = new QueryClient()

	return (
		<>
			<QueryClientProvider client={queryClient} contextSharing={true}>
				<Toolbar />
				<Suspense fallback={<div className="container">Loading...</div>}>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/debug" element={<Debug />} />
						
						<Route path="/posts" element={<Posts />} />
						<Route path="/users" element={<Users />} />
						<Route path="/albums" element={<Albums />} />
						<Route path="/photos" element={<Photos />} />

						<Route path="/files" element={<Files />} />

						<Route path="/about" element={<About />} />
						
						<Route path="/products" element={<Products />} />
						<Route path="/products/:slug" element={<ProductDetails />} />
						<Route path="*" element={<NoMatch />} />
					</Routes>
				</Suspense>
			</QueryClientProvider>
		</>
	);
};

export default App;
